type ModalTitlePropsType = {
  titlePosition?: 'center' | 'default';
  children: React.ReactNode;
};

/**
 * 타이틀 위치에 대한 style을 리턴한다.
 * @param {string} titlePosition - 타이틀 위치
 * @return {string} titlePositionStyle - 타이틀 위치 스타일
 */
const getTitlePositionStyle = (titlePosition: string = 'default') => {
  return (
    {
      center: 'flex justify-center',
      default: 'mobile:max-w-[340px] w-full',
    }[titlePosition] || ''
  );
};

const ModalTitle = ({
  titlePosition,
  children,
}: ModalTitlePropsType): React.ReactElement => {
  return (
    <h4
      className={`font_headline_bold_md content_primary mb-[24px]
      ${getTitlePositionStyle(titlePosition)}`}
    >
      {children}
    </h4>
  );
};

export default ModalTitle;
